import React, { useState, useContext } from 'react'
import { Pane, TextInput, Label, Button, Text, List } from '@leverege/ui-elements'
import { useValueChange } from '@leverege/ui-hooks'
import { JsonEditorDialog } from '../../views'

import RoleModel from './RoleModel'
import PermissionListEditor from './PermissionListEditor'
import S from './RoleEditor.css'

export default function RoleEditor( props ) {

  const { isCreate, isEditable = true, value : model, onChange, eventData } = props
  const [ showDialog, setShowDialog ] = useState( false )
  const onModelChange = useValueChange( RoleModel, props )
  
  // const onPermissionChange = ( event ) => {
  //   const { permission, index } = event.data
  //   const nPerm = { ...permission, usePermission : event.value }
  //   const nModel = RoleModel.setPermission( model, index, nPerm )
  //   console.log( 'onPermission', nModel )
  //   onChange( { value : nModel, oldValue : model, data: eventData } )
  // }

  if ( model == null ) {
    return (
      <Pane variant="padding">
        No Role Selected
      </Pane>
    )
  }
  const isCustom = RoleModel.getScope( model ) === 'custom'
  const metadata = RoleModel.getMetadata( model )

  return (
    <Pane variant="editor|padding">
      <div className={S.grid}>
        <Label variant="input">Name</Label>
        <TextInput
          hint="Unique role name"
          variant="role"
          value={RoleModel.getName( model )}
          size={30}
          eventData="setName"
          disabled={!isEditable || !isCustom}
          autoFocus
          onChange={onModelChange}/>
        <Label variant="input">Display Name</Label>
        <TextInput
          variant="role"
          value={RoleModel.getDisplayName( model )}
          size={30}
          eventData="setDisplayName"
          disabled={!isEditable}
          onChange={onModelChange}/>
        <Label variant="input">Category</Label>
        <TextInput
          variant="role"
          value={RoleModel.getCategory( model )}
          size={30}
          eventData="setCategory"
          disabled={!isEditable || !isCustom}
          onChange={onModelChange}/>
        <Label variant="input">Description</Label>
        <TextInput
          variant="role"
          value={RoleModel.getDescription( model )}
          size={30}
          eventData="setDescription"
          disabled={!isEditable}
          onChange={onModelChange}/>
        {isEditable && <Label variant="input">Metadata</Label>}
        {isEditable && <Button variant="secondarySmall" className={S.metadata} onClick={() => setShowDialog( true )}>Edit</Button> }
      </div>
      { model.id != null && (
        <PermissionListEditor 
          editable={isCustom}
          role={model}
          eventData="setPermissions"
          onChange={onModelChange} 
          permissions={model.permissions} />
      ) }

      <JsonEditorDialog 
        title="Metadata"
        message="Enter the JSON object for the metadata"
        show={showDialog} 
        onOk={( value ) => { 
          onModelChange( { value, data : 'setMetadata' } )
          setShowDialog( false )
        }}
        onCancel={() => { setShowDialog( false ) }}
        value={RoleModel.getMetadata( model )} />
    </Pane>
  )
}
